module.exports = __webpack_public_path__ + "efcb3265341f25c4005e529416685df7.svg";